<template>
  <article class="card cl-connection">
    <header class="cl-card-head is-tight">
      <div>
        <p class="eyebrow">Connection</p>
        <h3>Folder and monitoring</h3>
        <p class="muted-line">
          The folder is the one you picked yourself; logs are read locally, incrementally and never uploaded.
        </p>
      </div>
    </header>

    <div class="cl-status-details">
      <div class="cl-status-detail">
        <span>Access</span>
        <strong>{{ permissionLabel }}</strong>
        <small>Read-only, folder picked by you and stored as a handle</small>
      </div>
      <div class="cl-status-detail">
        <span>Monitoring</span>
        <strong>{{ monitorLabel }}</strong>
        <small>{{ observerSupported ? 'FileSystemObserver available' : 'Polling fallback, no FileSystemObserver' }}</small>
      </div>
      <div class="cl-status-detail">
        <span>Analysis</span>
        <strong>{{ usesWorker ? 'Web Worker' : 'Page thread' }}</strong>
        <small>{{ scanInfo.skipped ? `${scanInfo.skipped} non-text files skipped` : 'Logs are read locally and never uploaded' }}</small>
      </div>
      <div class="cl-status-detail is-actions">
        <button class="btn-sm-outline" type="button" @click="openPicker">
          <i class="fa-solid fa-file-arrow-up"></i> Select files
        </button>
        <button v-if="supported" class="btn-sm-outline" type="button" @click="$emit('connect')">
          <i class="fa-solid fa-folder-tree"></i> {{ directory.connected ? 'Change folder' : 'Choose folder' }}
        </button>
        <button v-if="directory.connected" class="btn-sm-outline" type="button" @click="$emit('disconnect')">
          <i class="fa-solid fa-link-slash"></i> Disconnect
        </button>
      </div>
      <p v-if="!supported" class="cl-status-note">
        This browser cannot keep access to a folder, so logs are analyzed from a manual selection. The analysis engine is
        the same; automatic monitoring is not available in this mode.
      </p>
    </div>

    <input ref="fileInput" class="cl-file-input" type="file" accept=".txt,text/plain" multiple @change="onFiles">
  </article>
</template>

<script>
// Everything about the folder itself: what access the page has, how it is
// being watched, and the manual file picker that stands in for a folder when
// the browser has no File System Access API. It used to hide behind a button
// on the status bar; it lives next to the log list instead, where someone
// looking for their logs will already be.

export default {
  name: 'CombatLogConnection',
  props: {
    supported: { type: Boolean, default: false },
    observerSupported: { type: Boolean, default: false },
    usesWorker: { type: Boolean, default: true },
    directory: { type: Object, required: true },
    monitorLabel: { type: String, default: '' },
    scanInfo: { type: Object, default: () => ({}) },
    files: { type: Array, default: () => [] },
  },
  emits: ['connect', 'disconnect', 'files'],
  computed: {
    permissionLabel() {
      if (!this.directory.connected) return this.files.length ? 'Manual files' : 'Not connected'
      if (this.directory.permission === 'granted') return 'Granted'
      if (this.directory.permission === 'denied') return 'Denied'
      return 'Needs confirmation'
    },
  },
  methods: {
    openPicker() {
      this.$refs.fileInput.click()
    },
    onFiles(event) {
      const files = event.target.files
      if (files && files.length) this.$emit('files', files)
      event.target.value = ''
    },
  },
}
</script>
